import { Box, Typography } from "@mui/material";
import Modal from "@mui/material/Modal";
import getTestIDs from "lib/utils/getTestIDs";
import { translations } from "translations";
export const testIDs = getTestIDs();

export const ErrorMessage = (
  <Box sx={{ padding: "16px" }}>
    <Typography variant="h5">{translations.globals.helpText.globalErrorMessageHeader}</Typography>
    <Typography variant="body1">{translations.globals.helpText.globalErrorMessage}</Typography>
  </Box>
);

export default function ErrorPage() {
  // Log that the error page was triggered
  console.error("[Global Error] ErrorPage rendered: a global error occurred.");
  const handleClose = () => {
    // eslint-disable-next-line no-restricted-globals
    location.reload();
  };

  return (
    <div>
      <Modal
        onClose={handleClose}
        // onConfirm={handleClose}
        // confirmLabel={translations.globals.terms.OK}
        open
        // testId={testIDs.erroModal}
      >
        {ErrorMessage}
      </Modal>
    </div>
  );
}
